// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Toast_v-application_1dJ7P","text-h1":"Toast_text-h1_2n66-","text-h2":"Toast_text-h2_3jOrA","messageText":"Toast_messageText_1sJGN"};